import { render, staticRenderFns } from "./ProjectUserPledgeMeta.vue?vue&type=template&id=08e92fc3"
import script from "./ProjectUserPledgeMeta.vue?vue&type=script&lang=js"
export * from "./ProjectUserPledgeMeta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports